// src/core/context/AuthClientContext.jsx — UNIFIÉ
// C'est LA SEULE source d'auth côté client.
// hooks/useAuthClient.js redirige ici pour compatibilité.
import React, { createContext, useContext, useState, useCallback } from "react";

const AuthClientContext = createContext();

export const AuthClientProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")) || null; }
    catch { return null; }
  });

  const login = useCallback((newToken, newUser) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("user", JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Nettoyer les anciennes clés de l'ancien hook si elles existent
    const keys = Object.keys(localStorage);
    keys.forEach(k => {
      if (k.startsWith("clientToken_") || k.startsWith("clientUser_")) {
        localStorage.removeItem(k);
      }
    });
    setToken("");
    setUser(null);
  }, []);

  const isAuthenticated = !!token;

  // Compatibilité avec l'ancien hooks/useAuthClient.js
  const getToken = useCallback(() => token, [token]);
  const getUser = useCallback(() => user, [user]);

  return (
    <AuthClientContext.Provider value={{
      token, user, login, logout, isAuthenticated,
      getToken, getUser
    }}>
      {children}
    </AuthClientContext.Provider>
  );
};

export const useAuthClient = () => useContext(AuthClientContext);